import styles from './DishFormSkeleton.module.scss';

const DishFormSkeleton = () => (
  <div className={styles.skeleton}>
    {/* Name */}
    <div className={styles.field}>
      <div className={styles.label} />
      <div className={styles.input} />
    </div>

    {/* Ingredients */}
    <div className={styles.field}>
      <div className={styles.label} />
      <div className={styles.textarea} />
    </div>

    {/* Price / Weight / Measure */}
    <div className={styles.priceRow}>
      <div className={styles.field}>
        <div className={styles.label} />
        <div className={styles.input} />
      </div>
      <div className={styles.field}>
        <div className={styles.label} />
        <div className={styles.input} />
      </div>
      <div className={styles.field}>
        <div className={styles.label} />
        <div className={styles.inputSmall} />
      </div>
    </div>

    {/* Photos */}
    <div className={styles.photosSection}>
      <div className={styles.label} />
      <div className={styles.photosList}>
        <div className={styles.photo} />
        <div className={styles.photo} />
        <div className={styles.photo} />
      </div>
      <div className={styles.addPhotoBtn} />
    </div>

    {/* Save button */}
    <div className={styles.button} />
  </div>
);

export default DishFormSkeleton;
